import React from "react";
import "./mit.css";

const MIT = () => {
  const images = [
    "/assets/images/mit/mit.webp",
    "/assets/images/mit/mit1.jpg",
  ];

  return (
    <div className="mit-section">
      <h2 className="innerpage-title">About MIT-ADT</h2>
      <p>
        The MIT-ADT Educational Group created history in 2016 when it opened the
        doors of its first institution on the breathtaking Vishwaraj Baug campus
        in Loni Kalbhor. The business acquired property that belonged to the
        late Indian actor Shri Raj Kapoorji in 2001. His tireless work enabled
        Rev. Prof. Dr. Vishwanath Karad to realize his goal of creating a
        university with an innovative and high caliber culture that was strongly
        rooted in the ideals of peace and development. Accordingly, MIT-ADT
        University has been established in the year 2016 by the Government of
        Maharashtra vide MIT Art, Design and Technology University Act, 2015
        (Mah. Act. No. XXXIX of 2015) and the university is in operation from
        academic year 2016-17.
      </p>
      <p>
        The University Grant Commission (UGC), New Delhi has recognized the MIT
        Art, Design and Technology University, Pune vide its letter No.
        F-8-33/2015 (CPP-1/PU), dated 10th November 2016 and University is
        empowered to issue the degrees specified in Section 22 of University
        Grants Commission Act, 1956.
      </p>

      <p>
        The MIT-ADT University is approved by Maharashtra state Government, the
        Gazette published on the 21st of August 2015. The MIT-ADT University is
        situated at Loni Kalbhor, Pune, and it is spread over 85 acres of land
        on the banks of Mula Mutha river. It is a leash green campus with state
        of the art facilities.
      </p>
       <div className="mit-images">
        {images.map((img, index) => (
          <div className="mit-image-wrapper" key={index}>
            <img src={img} alt={`mit-${index}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default MIT;
